import React from 'react';
import { Link } from 'react-router-dom';
import Profile from '../../Models/Profile';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class BuyerSidebar extends React.Component {
    constructor(props) {
        super(props);
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            minHeight: "475px",
            modalIsOpen: false,
            user: logged_user,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleLogout(e) {
        e.preventDefault();
        window.localStorage.removeItem('info')
        localStorage.clear();
        window.location.href = '/';
    }

    profilePic() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_pic')) {
            var pro_pic = JSON.parse(localStorage.getItem('pro_pic'))
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={pro_pic} style={{ width: "60%", height: "150px", objectFit: 'cover' }} />
                </div>
            )
        } else {
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={x.img_sidebar} style={{ width: "60%", height: "150px", objectFit: 'cover' }} />
                </div>
            )
        }
    }
    profileName() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_name')) {
            var pro_name = JSON.parse(localStorage.getItem('pro_name'))
            console.log(pro_name)
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{pro_name}</span>
                </div>
            )
        } else {
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{this.state.user.first_name}</span>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    {this.profilePic()}
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name">{this.state.user.first_name}</span>
                    </div>

                    <Link to={{
                        pathname: 'buyer-my-profile'
                    }} className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails">プロフィール</span>
                    </Link>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    {this.profilePic()}
                    {this.profileName()}
                    {/* <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name">{this.state.user.first_name}</span>
                    </div> */}

                    <Link to={{
                        pathname: 'buyer-my-profile'
                    }} className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails">プロフィール</span>
                    </Link>
                    <div className="mt-3 mb-3  input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }}>
                        メニュー
                </div>
                    <div className="bigger_pad">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-transaction'} className="color_alt sidebar_font">購入取引</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-request-home'} className="color_alt sidebar_font">リクエスト</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-dashboard'} className="color_alt sidebar_font" >購入一覧</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-favorites'} className="color_alt sidebar_font">お気に入り</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/followers-buyer'} className="color_alt sidebar_font">フォロー</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="bigger_pad">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-direct-message-list'} className="color_alt sidebar_font">メッセージ</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/buyer-change-password'} className="color_alt sidebar_font">パスワード変更</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'#'} onClick={this.handleLogout.bind(this)} className="color_alt sidebar_font">ログアウト</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }
}
export { BuyerSidebar }